import { Services } from '@sigma-frontend-libs/commons'
import { DICTIONARIES } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import buttonConfirmRemove from '@/components/button/confirm/remove'
import arrow from '@/components/misc/arrow'
import preloader from '@/components/preloader'
import localSearch from '@/components/services/dictionaries/localSearch'
import { dictionariesStatuses, dictionaryActions } from '@/components/services/dictionaries/utils'
import operatorGroups from '@/components/services/operatorGroups/template'
import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'

function renderPreloader(h) {
  if (this.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}
function renderId(h) {
  return h(
    sticker,
    {
      props: {
        value: { dictionaryId: this.value.id },
        label: this.label,
        pathToTitle: 'dictionaryId',
        copy: true,
        icon: dictionariesStatuses[this.value.status].icon,
        iconTooltip: this.getTranslate(`${Services.dictionaries}.statuses.${this.value.status}`),
        color: dictionariesStatuses[this.value.status].color
      }
    }
  )
}
function renderActionButton(h) {
  if (this.canUpdate) {
    return h(
      button,
      {
        class: 'hover-child',
        props: {
          label: this.getTranslate(`${Services.dictionaries}.buttons.${this.actionProps.action}`),
          mode: buttonModes.flat,
          color: this.actionProps.color
        },
        on: {
          click: event => {
            return this.actionHandler(this.actionProps.action, event)
          }
        }
      }
    )
  }
}
function renderRemoveButton(h) {
  if (this.canRemoveDictionariesAsResellerUp) {
    return h(
      buttonConfirmRemove,
      {
        class: 'hover-child',
        props: {
          showIcon: false,
          disabled: this.removeDisabled,
          callback: () => {
            return this.actionHandler(dictionaryActions.remove)
          }
        }
      }
    )
  }
}
function renderActions(h, trigger) {
  if (trigger) {
    return h(
      'div',
      {
        class: `${Services.dictionaries}-item__actions`
      },
      [
        renderActionButton.call(this, h),
        renderRemoveButton.call(this, h)
      ]
    )
  }
}
function renderCratedAt(h) {
  if (this.viewport.size.width > 380) {
    return h(
      'div',
      {
        class: `${Services.dictionaries}-item__header-createdAt`
      },
      [
        h(
          date,
          {
            props: {
              value: this.value
            }
          }
        )
      ]
    )
  }
}
function renderArrow(h, expanded) {
  if (this.hasContent) {
    return h(arrow, { props: { expanded } })
  }
}
function renderHeader(h, expanded) {
  return h(
    'div',
    {
      class: {
        [`${Services.dictionaries}-item__header`]: true,
        'cursor--pointer': this.hasContent,
        'hover-parent--opacity': this.viewport.breakpoint.mdUp
      }
    },
    [
      renderId.call(this, h),
      renderActions.call(this, h, this.viewport.size.width >= 780),
      renderCratedAt.call(this, h),
      renderArrow.call(this, h, expanded),
      renderPreloader.call(this, h)
    ]
  )
}
function renderOperatorGroups(h) {
  return h(
    operatorGroups,
    {
      props: {
        dictionary: this.value,
        removeCallback: () => {
          return this.actionHandler(dictionaryActions.remove)
        }
      }
    }
  )
}
function renderLocalSearch(h) {
  return h(localSearch, { props: { dictionary: this.value } })
}
function renderContentByType(h) {
  switch (this.value.type) {
    case DICTIONARIES['phone:mnp']:
    case DICTIONARIES['phone:ranges']: return renderLocalSearch.call(this, h)
    case DICTIONARIES['phone:opgroups']: return renderOperatorGroups.call(this, h)
  }
}
function renderActionsByType(h) {
  switch (this.value.type) {
    case DICTIONARIES['phone:mnp']:
    case DICTIONARIES['phone:ranges']: return renderActions.call(this, h, this.viewport.size.width < 780)
  }
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${Services.dictionaries}-item__body`
    },
    [
      renderContentByType.call(this, h),
      renderActionsByType.call(this, h)
    ]
  )
}

function renderSlots(h) {
  const result = {
    header: ({ expanded }) => {
      return renderHeader.call(this, h, expanded)
    }
  }
  if (this.hasContent) {
    result.default = () => {
      return renderBody.call(this, h)
    }
  }

  return result
}

export default function(h) {
  return h(
    components['expansion-panel'],
    {
      scopedSlots: renderSlots.call(this, h)
    }
  )
}
